import React from 'react'
import { PageProps } from 'gatsby' //, Link, graphql

import cn from 'classnames'

import SEO from '~/components/seo'
import Kv from '~/components/sub-kv'
import Tilt from '~/components/tilt'
import Shift from '~/components/shift'

import DeptIcon3 from '~/assets/svg/q-g1i.svg'
import DeptIcon4 from '~/assets/svg/q-g2i.svg'
import DeptIcon5 from '~/assets/svg/q-g3i.svg'

import ShiftLayerLargeImage from '~/assets/svg/v3/geo-4-top.svg'
import ShiftLayerLargeImageSp from '~/assets/svg/v3/geo-4-top-sp.svg'
import ShiftLayerQ1 from '~/assets/svg/q-g1.svg'
import ShiftLayerQ2 from '~/assets/svg/q-g3.svg'

import ShiftLayerImages1 from '~/assets/svg/v3/geo-5a.svg'
import ShiftLayerImages2 from '~/assets/svg/v3/geo-5b.svg'

import Arrow from '~/assets/svg/p-arrow-right.svg'

import s from '../../environment-systems/casestudy/styles.module.scss'
import getPrefixedPath from '~/utils/getPrefixedPath'

type DataProps = {}

const Page: React.FC<PageProps<DataProps>> = ({}) => (
  <>
    <SEO
      title="地理学科のフィールドワーク紹介"
      description="地理学科で実際に行われているフィールドワークの一例をご紹介します。横浜中華街にはなぜ、中国の人たちが住むようになったのか。そして、なぜこの街には中国以外の異国文化が垣間見えるのか。街中の小さな発見から、様々なことがわかってきます。"
    />

    <Shift
      className={s.shiftGeo1}
      startOffset={0}
      layer={[
        <div className={s.layer1}>
          <ShiftLayerLargeImage className={s.pc} />
          <ShiftLayerLargeImageSp className={s.sp} />
        </div>,
        <div className={s.layer2}>
          <Kv
            // title={
            //   <>
            //     中華街なのに、
            //     <br />
            //     中国と関係なさそうなお店があるのはなぜ？
            //   </>
            // }
            imgPc="/assets/images/pc/p-pc-g3-1.jpg"
            imgSp="/assets/images/sp/p-sp-g3-1.jpg"
          />
        </div>,
      ]}
    />
    <h1 className={s.geoH1}>
      中華街なのに、
      <br />
      中国と関係なさそうなお店があるのはなぜ？
    </h1>

    <section className={cn(s.content, s.geo)}>
      <div className={s.text}>
        <div className={s.flex}>
          <div className={s.left}>
            <div className={s.step}>step1</div>
            <h2>
              このお店にも、あのお店にも、
              <br />
              外国人の店員さんが。
            </h2>
            <p>
              最近、日本各地で働いている外国人を目にする機会が増えました。コンビニへ行けば、レジには外国人店員。日本は従来、単一民族的なイメージが強かったのですが、今では在留外国人が増加し、多民族化が進んできています。
              <br />
              海外はどこでも多民族社会です。海外から日本に来て生活している在留外国人との共存、共生は、今後の日本社会を考える上でも、重要な地理学的テーマの一つになっています。
              <br />
              ここでは、地理学を学ぶことで身につく、社会のさまざまな問題に取り組む知識と方法について説明します。
            </p>
          </div>
          <div className={cn(s.right)}>
            <Shift
              className={s.shiftGeo2}
              layer={[
                <div className={s.layer1}>
                  <ShiftLayerQ1 />
                </div>,
                <div className={s.layer2}>
                  <Tilt direction="right">
                    <img
                      src={getPrefixedPath(
                        '/assets/images/pc/v4/p-half-geo-2.jpg'
                      )}
                    />
                  </Tilt>
                  <p className={s.caption}>
                    ニューヨーク郊外クイーンズ区フラッシング
                    <br />
                    世界各地からの新規の移民が集まり、
                    <br />
                    ニューヨークでもっとも活気のある地区ともいわれています。
                  </p>
                </div>,
              ]}
            />
          </div>
        </div>

        <div className={s.flex}>
          <div className={s.left}>
            <div className={s.step}>step2</div>
            <h2>
              横浜中華街にも、
              <br />
              不思議がたくさん。
            </h2>
            <p>
              日本にも、古くから外国人が集まって街をつくってきたところがあります。その一つが横浜中華街です。地理学科の学生たちと、横浜中華街でフィールドワークを行いました。
              <br />
              まずは、地図を見ながら海岸に面した山下公園から歩き始めました。山下公園の標高は2.4ｍですが、ここから横浜中華街へ進むと、少し下り坂になります。つまり標高は海に近い方が高く、中華街のシンボルである善隣門付近の標高は1.4ｍです。横浜中華街が1ｍあまりも低くなっているのはなぜでしょうか。
              <br />
              現在の横浜中華街はもともと海で、江戸時代の新田開発でつくられた「横浜新田」だったところです。幕末の開港で、横浜に外国人居留地がつくられました。欧米人は港に近い海岸に面した砂州(さす)に貿易事務所を建てました。そして、外国人墓地がある山手の丘陵地に屋敷を建てて住みました。一方、欧米人に雇われ貧しかった中国人たちは、かつて横浜新田であった低湿地に集まって住むようになりました。そこが、今や横浜を代表する観光地、横浜中華街になったわけです。
              <br />
              学生たちは、グループに分かれて、横浜中華街の土地利用調査をして、横浜中華街の土地利用図を作成しました。土地利用調査をしながら、学生たちは、横浜中華街のさまざまな面にも気づきました。
              <br />
              ・「2時間食べ放題で1680円」、「焼きショーロンポー1個100円」など、低価格競争が激しい。
              <br />
              ・中華街なのに、占いの店が目立つ。それ以外にも中国とは関係なさそうな店も進出している。
              <br />
              このような「発見」の理由・要因などを探っていくと、横浜中華街だけでなく、日本や世界各地の外国出身者が形成した街の成り立ちや、そこで暮らす人々の共通点やその地域ならではの特色なども見えてきます。
            </p>
          </div>

          <div className={cn(s.right)}>
            <Shift
              className={s.shiftGeo3}
              layer={[
                <div className={s.layer1}>
                  <ShiftLayerQ2 />
                </div>,
                <div className={s.layer2}>
                  <Tilt direction="left">
                    <img
                      src={getPrefixedPath(
                        '/assets/images/pc/v4/p-half-geo-3.jpg'
                      )}
                    />
                  </Tilt>
                </div>,
              ]}
            />
          </div>
        </div>

        <Shift
          relativeSp
          className={s.shiftGeo4}
          startOffset={0}
          layer={[
            <div className={s.layer1}>
              <ShiftLayerImages1 />
              <ShiftLayerImages2 />
            </div>,
            <div className={s.layer2}>
              <div className={cn(s.images, s.flex)}>
                <div className={cn(s.left, s.top, s.flex)}>
                  <div className={cn(s.left, s.top)}>
                    <img
                      src={getPrefixedPath('/assets/images/pc/v4/geo-c1.jpg')}
                    />
                    <p className={s.caption}>
                      横浜中華街からみた山下公園（海岸）方面
                      <br />
                      写真中央の朝陽門（東門）の先に山下公園があります。
                    </p>
                  </div>
                  <div className={cn(s.right, s.top)}>
                    <img
                      src={getPrefixedPath('/assets/images/pc/v4/geo-c2.jpg')}
                    />
                    <p className={s.caption}>
                      学生たちがフィールドワークで作成した
                      <br />
                      横浜中華街の土地利用図（2018年6月）
                    </p>
                  </div>
                </div>
                <div className={cn(s.right, s.top, s.flex)}>
                  <div className={cn(s.left, s.top)}>
                    <img
                      src={getPrefixedPath('/assets/images/pc/v4/geo-c3.jpg')}
                    />
                    <p className={s.caption}>横浜中華街のシンボル，善隣門</p>
                  </div>
                  <div className={cn(s.right, s.top)}>
                    <img
                      src={getPrefixedPath('/assets/images/pc/v4/geo-c4.jpg')}
                    />
                    <p className={s.caption}>1680円で食べ放題の中国料理店</p>
                    <img
                      src={getPrefixedPath('/assets/images/pc/v4/geo-c5.jpg')}
                    />
                    <p className={s.caption}>横浜中華街で増加している占い店</p>
                  </div>
                </div>
              </div>
            </div>,
          ]}
        />

        <div className={s.flex}>
          <div className={s.left}>
            <div className={s.step}>step3</div>
            <h2>
              研究テーマが、
              <br />
              国境を越えてつながっていく。
            </h2>
            <p>
              横浜中華街の形成過程を考えるときには、砂州、新田開発のようなキーワードにあらわれる自然地理学や歴史地理学、さらに近現代史などの知識も必要になります。
              <br />
              地理学では、フィールドワークに出かけるとき、必ず地図をもっていきます。地図を見ながら歩き回ります。その過程で、学生たちも、安売りの店や占い店が多いことなどに気づきました。そして、「何で多いのだろう」という疑問が出てきます。そのような疑問を解いていくのが「研究」です。地理学を学ぶと、国内・国外を問わず、いろいろなところを歩いているうちに、多くの人が気付かないこともわかるようになります。地域を見る目が養われてくるからです。
              <br />
              最近、海外各地では寿司店や日本料理店が目立ちます。地理学を学んだ者は、店の外観に着目するはずです。店の名前が「ARIGATO」、「OISHII」であれば、経営者は日本人ではないだろうと推測します。メニューをよく見ると、中国料理や韓国料理が含まれていたら、答えはおわかりでしょう。これは海外で生活する中国人や韓国人が、「日本」の姿を借りて現地社会で生活していこうとしているのです。これは「借り傘戦略」といわれる、マイナーな集団がよりメジャーな集団の姿を借りることで生き残ろうとするものです。
              <br />
              身近な例をあげてみましょう。最近、日本各地で外国人経営のカレー店が増えたと思いませんか。価格は安いし、大きなナンが目立ちます。注文した料理が運ばれてくるまで、店内をよく観察してみてください。三角形の旗に気づきましたか。ネパールの国旗です。ほとんどの日本人はライスでなくナンを選びます。食後、店を出て、もう一度店の看板をよく見てください。「インド・ネパール　カレー」の店です。これもネパール人が「インド」の姿を借りた「借り傘戦略」なのです。
            </p>
          </div>
          <div className={cn(s.right, s.bottom)}>
            <div className={s.paddingTop}>
              <Tilt direction="right">
                <img
                  src={getPrefixedPath('/assets/images/pc/v4/p-half-geo-4.jpg')}
                />
              </Tilt>
              <p className={s.caption}>
                ネパール人経営の「インド・ネパールレストラン」
              </p>
            </div>
          </div>
        </div>

        <div className={s.flex}>
          <div className={s.left}>
            <div className={s.step}>step4</div>
            <h2>
              スペシャリストであると同時に、
              <br />
              多様化・複合化が進む社会で
              <br />
              活躍できるジェネラリストになろう。
            </h2>
            <p>
              日本の総人口は2011年の1億2783万人をピークに、減少を続けています。同時に少子高齢化も急速に進んでいます。県庁所在地の中心部の商店街も、シャッター街化しています。工場でも農家でも、建築現場でも介護施設でも、若い労働力が不足しています。このような危機的状況を支えているのが外国人労働者です。コンビニで働きながら日本語学校で学ぶ留学生、賃金が高い夜間、スーパーマーケットやコンビニで売られる弁当やサンドイッチをつくっているのも外国人が多いです。レタス、メロンなどを大規模に栽培している農業も、外国人技能実習生がいなければ成り立ちません。多民族化は外国の話ではありません。
              <br />
              地理学は、大きく人文地理学、自然地理学に二分され、さらにそれぞれ都市地理学、観光地理学のような「〇〇地理学」などに細分化されます。他の学問分野と比べ、地理学の強みは、国内外の多様な社会問題に対応できることです。人文地理学で専門的な卒業論文を書く「スペシャリスト」（特定の専門分野に精通している人）であっても、自然地理学の基礎も学んでいるため、自然災害にも対応できます。経済学、社会学、歴史学、文化人類学などの境界領域、そして海外の諸問題も学んでいます。しかも、地図が読めて、さらに自ら地図を作成することもできる「ジェネラリスト」なのです。多様な専門性を活かして総合的な判断ができる「ジェネラリスト」は、多様化・複合化が進む現代社会に求められる人材といえるでしょう。
              <br />
              地理学を学ぶと、コンビニの外国人店員に会った際に、「出身はどこの国ですか？」「頑張ってください！」と自然に言葉が出るようになるはずです。（山下清海研究室）
              <br />
              ※山下清海先生は2021年度末をもって立正大学を退職されました。
            </p>
          </div>
          <div className={cn(s.right, s.bottom)}>
            <div className={s.paddingTop}>
              <Tilt direction="left">
                <img
                  src={getPrefixedPath('/assets/images/pc/v4/p-half-geo-5.jpg')}
                />
              </Tilt>
              <p className={s.caption}>
                海外フィールドワーク（北京，天安門広場にて）
              </p>
            </div>
          </div>
        </div>

        <div className={cn(s.icons, s.flex)}>
          <DeptIcon3 className={cn(s.icon3)} />
          <DeptIcon4 className={cn(s.icon4)} />
          <DeptIcon5 className={cn(s.icon5)} />
        </div>

        <div className={s.link}>
          <p>
            上記の内容はあくまでも一例です。地理学科では、国内外問わずあらゆる地域のあらゆる問題に対し、総合的な視点で向き合うことができます。もっと詳しく知りたい方は、オープンキャンパスや学科サイト、デジタルパンフレット、LINEからどうぞ。
          </p>
          <a href="#learn-more">
            もっと知る
            <Arrow />
          </a>
        </div>
      </div>
    </section>
  </>
)

export default Page
